import { render, staticRenderFns } from "./ContactSelector.vue?vue&type=template&id=b1e579b4"
import script from "./ContactSelector.vue?vue&type=script&lang=js"
export * from "./ContactSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports